import { useIsMutating, useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useIsMutationCancelled } from 'utils/helpers/reactQueryHelpers';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getTextAnalysis } from 'services/performanceReview';

import { setFeedbackAnalysis, setSelectedRevision, useSelectedRevision } from '../slice/meshMavenSlice';
import { FeedbackAnalysisAPIResponse, FeedbackAnalysisRequestBody } from '../types/FeedbackAnalysis';

export const useAnalyzeTextMutation = () => {
  const dispatch = useDispatch();
  const selectedRevision = useSelectedRevision();

  const isMutationCancelled = useIsMutationCancelled();

  return useMutation<FeedbackAnalysisAPIResponse, { message?: string }, FeedbackAnalysisRequestBody>(
    (params) =>
      getTextAnalysis({
        ...params,
        revisionNumber: params.revisionNumber + 1,
      }),
    {
      mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.analyzeText],
      onError: (error) => {
        console.log('error', error);
      },
      onSuccess: (data) => {
        if (isMutationCancelled([REACT_QUERY_KEYS.reviewsGenAi.analyzeText])) {
          return;
        }
        dispatch(
          setSelectedRevision({
            revision: {
              ...selectedRevision,
              isReanalyzeEnabled: false,
            },
          })
        );
        dispatch(setFeedbackAnalysis({ feedbackAnalysis: data.labels }));
      },
    }
  );
};

export const useAnalyzeTextMutationLoading = () =>
  useIsMutating({
    mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.analyzeText],
  }) > 0;
